import { createAction, props } from '@ngrx/store';
import { ILegalEntitiesBusinessesResponse } from '../models/businesses.model';

export const loadBusinesses = createAction('[LegalEntities] Load Legal Entities Businesses', props<{ param: string; noLoader: boolean }>());

export const loadBusinessesSuccess = createAction(
  '[LegalEntities] Load Legal Entities Businesses Success',
  props<{ response: ILegalEntitiesBusinessesResponse[] }>()
);

export const loadBusinessesFailure = createAction(
  '[LegalEntities] Load Legal Entities Businesses Failure',
  props<{ error: Error | any }>()
);

export const loadLegalEntityTabControls = createAction('[LegalEntities] Load Legal Entity Tab Controls', props<{ tabIndex: number }>());
